export default "__VITE_ASSET__f21ffc73__"